import { BehaviorSubject } from 'rxjs';
import { useBehaviorSubjectValue } from './utils';
export const loadingThemeOverride$ = new BehaviorSubject(undefined);
/**
 * Sets the initial theme for the report components. This includes the initial loading text and the
 *   login screen.
 */
export function setLoadingTheme(value) {
    loadingThemeOverride$.next(value);
}
export function getLoadingTheme() {
    return loadingThemeOverride$.getValue();
}
export function useLoadingTheme() {
    return useBehaviorSubjectValue(loadingThemeOverride$);
}
